import '../index.css'
import * as React from 'react'
import Modal from 'react-modal'
import img1x from 'assets/images/referral.png'
import img2x from 'assets/images/referral@2x.png'
import Button from 'components/ui/button'
import Heading from 'components/ui/heading'
import modalStyles from 'components/utils/modalStyles'
type Props = {
  onClose: (...args: Array<any>) => any
}
export default class ReferralInviteThankYouModal extends React.Component<Props> {
  render(): React.ReactNode {
    return (
      <Modal onRequestClose={this.props.onClose} isOpen style={modalStyles}>
        <div className="modal-width--600">
          <div className="Referral_Content">
            <div className="Referral_Header">
              <div className="Referral_CloseBtn">
                <Button
                  appearance="icon"
                  icon="close"
                  onClick={this.props.onClose}
                />
              </div>
              <Heading size={700}>Thank you!</Heading>
              <div className="Referral_Intro">
                Thanks so much for helping us spread the word.
                <br />
                We&#39;ll let you know when your friend signs up :)
              </div>
            </div>
            <img srcSet={`${img1x}, ${img2x} 2x`} />
          </div>
        </div>
      </Modal>
    )
  }
}
